export const getOpen = (state) => state.auth.verifyEmail.open;
export const getEditEmail = (state) => state.auth.verifyEmail.editEmail;
export const getVerified = (state) => state.auth.verifyEmail.verified;
export const getCode = (state) => state.auth.verifyEmail.code;
export const getEmail = (state) => state.auth.verifyEmail.email;
export const getProfileEmail = (state) => state.auth.verifyEmail.profileEmail;
export const getErrorMessage = (state) => state.auth.verifyEmail.errorMessage;
export const getLoading = (state) => state.auth.verifyEmail.loading;
